import React from "react";
import PropTypes from "prop-types";
import { withAuth } from "shared/context/auth";
import { withTheme } from "shared/context/theme";
import Avatar from "backpack-ui/dist/components/avatar";
import config from "../../config";
import TextItem from "../TextItem";
import styles from "./styles.css";
import themes from "./themes";

class UserItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // Target link (current location href) is avaialble for client render only
      // and it needs to be initially disabled to avoid the "prop x did not
      // match" SSR warnings.
      signInItemUrl: config.getSignInItem({ includeTargetLink: false }).url,
    };
  }

  componentDidMount() {
    this.setState({
      signInItemUrl: config.getSignInItem().url,
    });
  }

  render() {
    const { auth, theme } = this.props;
    const { signInItemUrl } = this.state;

    if (auth.isUserSignedIn) {
      const { user } = auth;
      const userMenu = config.getUserDesktopMenu(user);

      return (
        <TextItem
          title={userMenu.title}
          url={userMenu.url}
          key={signInItemUrl}
          submenu={userMenu.submenu}
          className={theme.styles.avatar}
          activeClassName={theme.styles.isActive}
        >
          <Avatar src={user.avatar} alt={user.username} size={40} />
        </TextItem>
      );
    }

    return (
      <TextItem
        {...config.getSignInItem()}
        url={signInItemUrl}
        className={theme.styles.signInButton}
        activeClassName={theme.styles.isActive}
      />
    );
  }
}

UserItem.propTypes = {
  auth: PropTypes.shape({
    isUserSignedIn: PropTypes.bool,
    user: PropTypes.shape({
      username: PropTypes.string,
      avatar: PropTypes.string,
    }),
  }).isRequired,
  theme: PropTypes.shape({
    styles: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export default withAuth(withTheme(UserItem, styles, themes));
